import { writable } from "svelte/store";

export const apiUrl = writable();
export const apiKey = writable();

export const schemaId = writable();